/* PyreFit · Canada only (ca.pyrefit.com, en + fr).
   Shows body and garment measurements imperial first with the metric value in parentheses:
   5'8" (172 cm) · 128–150 lb (58–68 kg) · 43.3 in (110 cm)  |  fr: 5 pi 8 po (172 cm) · 43,3 po (110 cm).
   Display only: the source data (section settings, option values, data-* attributes) never changes.
   Loaded by snippets/pf-ca-units.liquid, which renders only when localization.country is CA. */
(() => {
  if (window.pfCaUnits) return;
  const cfgEl = document.getElementById('pf-ca-units');
  if (!cfgEl) return;
  let cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  const FR = cfg.lang === 'fr';
  const IN = FR ? 'po' : 'in';
  // No-break spaces keep a value and its unit on one line in narrow table cells.
  const NB = '\u00a0';
  const HEAD_UNIT = FR ? `po${NB}/${NB}cm` : `in${NB}/${NB}cm`;
  // Column labels used on ca. only (fr: « Taille » for the wearer's height, « Poids / Taille » for the weight x height grid).
  const box0 = document.createElement('textarea');
  const label = k => { const v = cfg.labels?.[k]; if (!v || /translation missing/i.test(v)) return ''; box0.innerHTML = v; return box0.value.trim(); };
  const LABELS = { heightSrc: label('height_src'), height: label('height'), matrixSrc: label('matrix_src'), matrix: label('matrix') };
  const ROOTS = '[data-size-dialog],.pf-apparel-size-table,.jacket-size-guide,[data-size-content],.pf-fjord-table,.pf-foot-fit,.pf-slippers-size-options,.pf-sl-rte,.pwt-size-hint,.plaid-buybox,.plaid-accordion,.plaid-lower,.plaid-gallery,.plaid-material-value,[data-pf-ca-units]';
  // Garment tables whose bare numbers are centimetres even without a unit in the header.
  const CM_DEFAULT = '[data-size-dialog],.pf-apparel-size-table,.jacket-size-guide,[data-size-content],.pf-fjord-table';
  // Shoe sizes: same chart as the product translations (Nike chart): EU -> [US W, US M].
  const SHOE = {34:['3.5','2'],35:['4.5','3'],36:['5.5','4'],37:['6–6.5','4.5–5'],38:['7','5.5'],39:['8','6.5'],40:['8.5','7'],41:['9.5','8'],42:['10','8.5'],43:['11','9.5'],44:['11.5','10'],45:['12.5','11'],46:['13.5','12']};

  const num = s => Number(String(s).replace(',', '.'));
  const dec = s => FR ? String(s).replace(/\./g, ',') : String(s).replace(/,/g, '.');
  const fmt = (x, d) => { const r = Number(x.toFixed(d)); return dec(String(r)); };
  const inch = cm => fmt(Math.round(cm / 2.54 * 10) / 10, 1);
  const lb = kg => { const v = kg / 0.453592; return v >= 10 ? String(Math.round(v)) : fmt(Math.round(v * 10) / 10, 1); };
  const ftin = cm => { const t = Math.round(cm / 2.54), f = Math.floor(t / 12), i = t % 12; return FR ? (i ? `${f}${NB}pi${NB}${i}${NB}po` : `${f}${NB}pi`) : `${f}'${i}"`; };
  const NUM = '\\d+(?:[.,]\\d+)?';
  const Q = `${NUM}(?:\\s*[×x]\\s*${NUM}){0,2}`;
  const CONN = '(?:\\s*[–-]\\s*|,\\s+|\\s+(?:to|à|and|et|or|ou)\\s+)';
  const CHAIN = new RegExp(`(${Q}(?:${CONN}${Q})*)(\\s*)(cm|kg)(?![²³\\w])`, 'g');
  const IMPERIAL_BEFORE = /(?:\bin|\bpo|\blb|\boz|"|\bpi)\s*\(\s*$/;
  const HEIGHT_WORDS = /(height|tall|grandeur|stature|mesurant|körpergröße)[^.;]{0,40}$/i;
  const alreadyImperial = s => /\d\s*(?:in|po|lb|oz)\b|\d'\d|\d\s*pi\b/.test(s);

  // One quantity ("110", "66,5", "130 × 160") -> imperial
  const convQty = (q, unit, height) => q.split(/\s*[×x]\s*/).map(p => unit === 'kg' ? lb(num(p)) : height ? ftin(num(p)) : inch(num(p))).join(' × ');
  const metric = s => s.replace(new RegExp(NUM, 'g'), m => dec(m));
  // Whole chain "22 to 26", "58–68", "130 × 160, 150 × 200 and 200 × 230"
  // bare: garment-measurement table cell whose column header already says "(in / cm)" -> "41.7 (106)"
  function convChain(chain, unit, height, bare) {
    const parts = chain.split(new RegExp(`(${CONN})`));
    const imp = parts.map((p, i) => i % 2 ? (height && FR && /[–-]/.test(p) ? ' – ' : p) : convQty(p, unit, height)).join('');
    if (bare) return `${imp} (${metric(chain)})`;
    const u = unit === 'kg' ? 'lb' : height ? '' : IN;
    return `${imp}${u ? NB + u : ''} (${metric(chain)}${NB}${unit})`;
  }
  function convText(text, forceHeight) {
    if (!/\d\s*(cm|kg)|EU\s?\d{2}/.test(text)) return text;
    let out = text.replace(CHAIN, (m, chain, sp, unit, off, all) => {
      const before = all.slice(0, off);
      if (IMPERIAL_BEFORE.test(before)) return m;
      const height = unit === 'cm' && (forceHeight || HEIGHT_WORDS.test(before));
      return convChain(chain, unit, height);
    });
    if (!/\bUS\s?[WMFH]\b/.test(out)) out = out.replace(/\bEU\s?(\d{2})(?:\s*[–-]\s*(\d{2}))?\b(?!\s*[–-]?\s*\d)(?!\s*\(US)/g, (m, a, b) => {
      const lo = SHOE[a], hi = SHOE[b || a];
      if (!lo || !hi) return m;
      const r = i => { const x = lo[i].split('–')[0], y = hi[i].split('–').pop(); return dec(x === y ? x : `${x}–${y}`); };
      return `${m} (US ${FR ? 'F' : 'W'} ${r(0)} / ${FR ? 'H' : 'M'} ${r(1)})`;
    });
    return out;
  }
  // Bare table cell: "110", "66,5", "≤ 166", "48–58", "172–178 cm", "166+"
  const CELL = new RegExp(`^(\\s*(?:[≤≥<>~]|ca\\.|env\\.)?\\s*)(${NUM}(?:\\s*[–-]\\s*${NUM})?)(\\s*\\+)?\\s*(cm|kg)?\\s*$`);
  function convCell(text, type) {
    if (alreadyImperial(text) || /\d\s*\)\s*$/.test(text)) return null;
    const m = text.match(CELL);
    if (!m) return null;
    const unit = m[4] || (type === 'weight' ? 'kg' : type === 'size' || type === 'none' ? '' : 'cm');
    if (!unit) return null;
    const height = unit === 'cm' && type === 'height';
    const bare = unit === 'cm' && type === 'length';
    const plus = m[3] ? m[3].trim() : '';
    return m[1] + convChain(m[2], unit, height, bare).replace(/ \(/, plus + ' (').replace(/\)$/, bare && plus ? plus + ')' : ')');
  }
  const pfCol = c => (c?.dataset?.pfCol || '') + ' ' + (c?.textContent || '');
  const SIZE_VALUE = /^(?:[2-9]?X{0,3}[SML]|[2-9]XL|X{1,3}L|[SML](?:\/[SML]){1,2}|—|-|\s*)$/i;
  // index/rows: a "Taille" header in fr is the size column only when it is the row label or holds size letters
  // (in the jacket chart a later "Taille" column is the waist measurement).
  function colType(head, cmDefault, index, rows) {
    if (!head) return cmDefault ? 'length' : 'none';
    const label = pfCol(head);
    const small = head.querySelector('.pf-unit')?.textContent.trim() || '';
    if (/gewicht|weight|poids/i.test(label) || small === 'kg' || /\(kg\)/.test(label)) return 'weight';
    const src = head.dataset?.pfCol || '';
    if (/^(Empfohlene )?Körpergröße|^Körper( \(|$)/.test(src) || /^(recommended )?(height|grandeur|stature|taille recommandée)/i.test((head.textContent || '').trim())) return 'height';
    const bare = (head.textContent || '').replace(/\([^)]*\)/g, '').trim();
    if (/^Größe$/.test(src) || /^(größe|size|pointure|eu)$/i.test(bare)) return 'size';
    if (/^taille$/i.test(bare)) {
      const values = (rows || []).map(r => (r.cells[index]?.textContent || '').trim());
      if (!index || values.every(v => SIZE_VALUE.test(v))) return 'size';
    }
    if (small === 'cm' || /\(cm\)|\bcm\b/.test(label)) return 'length';
    return cmDefault ? 'length' : 'none';
  }
  const UNIT_TAIL = `(${HEAD_UNIT})`;
  function fixHead(head, type) {
    if (!head || head.dataset.pfCaHead === head.textContent) return;
    const small = head.querySelector('.pf-unit');
    if (small) { if (type === 'height' || type === 'weight') small.remove(); else if (small.textContent.trim() === 'cm') small.textContent = UNIT_TAIL; }
    let hasUnit = !!head.querySelector('.pf-unit');
    for (const n of textNodes(head)) {
      const v = n.nodeValue;
      let w = v.replace(/\s*\(kg\)/g, '');
      w = type === 'height' ? w.replace(/\s*\(cm\)/g, '') : w.replace(/\(cm\)/g, UNIT_TAIL);
      if (w.includes(UNIT_TAIL)) hasUnit = true;
      if (type === 'height' && LABELS.height && LABELS.heightSrc && w.trim() === LABELS.heightSrc) w = w.replace(LABELS.heightSrc, LABELS.height);
      if (type === 'matrix' && LABELS.matrix && LABELS.matrixSrc && w.trim() === LABELS.matrixSrc) w = w.replace(LABELS.matrixSrc, LABELS.matrix);
      if (w !== v) n.nodeValue = w;
    }
    // Garment-measurement column without any unit in its header (jacket and Nordik charts): the cells are bare "41.7 (106)".
    if (type === 'length' && !hasUnit && head.textContent.trim()) head.append(` ${UNIT_TAIL}`);
    head.dataset.pfCaHead = head.textContent;
  }
  function isMatrix(table) {
    return table.dataset.matrixTable === 'true' || /Gewicht.*Körpergröße|weight.*height|poids.*grandeur/i.test(pfCol(table.rows[0]?.cells[0]));
  }
  function setCell(cell, type) {
    if (cell.dataset.pfCa && cell.dataset.pfCa === cell.textContent) return;
    if (cell.querySelector('table')) return;
    const nodes = textNodes(cell);
    if (nodes.length !== 1) { cell.dataset.pfCa = cell.textContent; return; }
    const out = convCell(nodes[0].nodeValue, type);
    if (out != null) {
      nodes[0].nodeValue = out;
      cell.dataset.pfCaConv = type;
      // Stacked mobile layout of the jacket chart prints the column name from data-label before the bare value.
      const dl = cell.getAttribute('data-label');
      if (type === 'length' && dl && !dl.includes(UNIT_TAIL)) cell.setAttribute('data-label', `${dl} ${UNIT_TAIL}`);
    }
    cell.dataset.pfCa = cell.textContent;
  }
  function convTable(table) {
    const rows = [...table.rows];
    if (!rows.length) return;
    if (table.dataset.adviceTable === 'true' || table.closest('.pf-fit-advice')) return;
    const cmDefault = !!table.closest(CM_DEFAULT);
    if (isMatrix(table)) {
      [...rows[0].cells].slice(1).forEach(c => setCell(c, 'height'));
      rows.slice(1).forEach(r => r.cells[0] && setCell(r.cells[0], 'weight'));
      fixHead(rows[0].cells[0], 'matrix');
      return;
    }
    const headRow = rows[0];
    const heads = [...headRow.cells];
    const headerIsLabels = heads.every(h => h.tagName === 'TH');
    const body = rows.slice(headerIsLabels ? 1 : 0);
    const types = heads.map((h, i) => h.tagName === 'TH' ? colType(h, cmDefault, i, body) : (cmDefault ? 'length' : 'none'));
    body.forEach(r => [...r.cells].forEach((c, i) => {
      if (i === 0 && c.tagName === 'TH' && types[0] !== 'height' && types[0] !== 'weight') return;
      setCell(c, headerIsLabels ? types[i] : 'none');
    }));
    // A header gets "(in / cm)" only when its column really holds converted garment measurements.
    if (headerIsLabels) heads.forEach((h, i) => {
      const used = body.some(r => r.cells[i]?.dataset.pfCaConv);
      fixHead(h, types[i] === 'length' && !used ? 'none' : types[i]);
    });
  }
  function textNodes(root) {
    const out = [], w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) out.push(w.currentNode);
    return out;
  }
  const box = document.createElement('textarea');
  const decode = v => { box.innerHTML = String(v || ''); return box.value; };
  const pairs = (cfg.pairs || []).map(p => (p || []).map(decode)).filter(p => p[0] && p[1] && p[0] !== p[1] && !/translation missing/i.test(p[0] + p[1]));
  if (cfg.foot?.placeholder) cfg.foot.placeholder = /translation missing/i.test(cfg.foot.placeholder) ? '' : decode(cfg.foot.placeholder);
  function convFree(root) {
    for (const n of textNodes(root)) {
      if (n.parentElement?.closest('td,th,script,style,input,textarea,[data-pf-ca-skip]')) continue;
      let v = n.nodeValue, w = v;
      for (const [a, b] of pairs) if (w.includes(a)) w = w.split(a).join(b);
      const force = !!n.parentElement?.closest('.pf-matrix-item summary b');
      // Mobile blocks of the weight x height grid: "Grandeur 5 pi 1 po …" -> "Taille 5 pi 1 po …" (fr), same label as the column.
      if (LABELS.height && LABELS.heightSrc && n.parentElement?.matches('.pf-matrix-item summary') && w.trim() === LABELS.heightSrc) w = w.replace(LABELS.heightSrc, LABELS.height);
      w = convText(w, force);
      if (w !== v) n.nodeValue = w;
    }
    root.querySelectorAll('img[alt]').forEach(img => { const a = img.getAttribute('alt'); const b = convText(a); if (a !== b) img.setAttribute('alt', b); });
  }
  // Slippers option pills: "24–24.5<small class=pf-foot-option-unit>cm</small>"
  function convFootOptions(root) {
    root.querySelectorAll('.pf-foot-option-unit').forEach(small => {
      if (small.dataset.pfCa) return;
      const t = small.previousSibling;
      if (small.textContent.trim() !== 'cm' || !t || t.nodeType !== 3 || alreadyImperial(t.nodeValue)) return;
      const m = t.nodeValue.trim().match(new RegExp(`^${NUM}(?:\\s*[–-]\\s*${NUM})?$`));
      if (!m) return;
      const full = convChain(m[0], 'cm', false);
      const cut = full.indexOf(' (');
      t.nodeValue = full.slice(0, cut).replace(new RegExp(`\\s${IN}$`), '');
      small.textContent = `${IN} ${full.slice(cut + 1)}`;
      small.dataset.pfCa = '1';
    });
    root.querySelectorAll('[data-foot-length]').forEach(input => {
      if (input.dataset.pfCa) return;
      input.dataset.pfCa = '1';
      const after = input.nextSibling;
      if (after && after.nodeType === 3 && after.nodeValue.trim() === 'cm') after.nodeValue = ` ${HEAD_UNIT}`;
      if (cfg.foot?.placeholder) input.placeholder = cfg.foot.placeholder;
    });
  }
  function run() {
    observer.disconnect();
    try {
      document.querySelectorAll(ROOTS).forEach(root => {
        if (root.parentElement?.closest(ROOTS)) return; // handled by the outer root
        // The PyreFit size dialogs are rebuilt by their component on first use; wait until it is done.
        if (!settled && root.matches('[data-size-dialog]') && root.closest('pf-apparel,jacket-nineheat-main,pf-fjord') && !root.dataset.sizeUsable) return;
        root.querySelectorAll('table').forEach(convTable);
        convFootOptions(root);
        convFree(root);
      });
    } finally {
      observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-size-usable'] });
    }
  }
  let timer = 0, settled = false;
  window.addEventListener('load', () => setTimeout(() => { settled = true; run(); }, 800), { once: true });
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(run, 30); });
  window.pfCaUnits = { convText, convCell, run, lang: cfg.lang };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
